<template>
    <div>
    <swiper-container
        :slides-per-view="1"
        :space-between="50"
        :loop="true"
        :pagination="{ clickable: true }"
        :autoplay="{ delay: 5000, disableOnInteraction: false }"
        :touchMoveStopPropagation="true"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        virtual="true"
        class='swiper_pc' >
        <swiper-slide lazy="true">
            <img src='../assets/CompanyAddress_wide.jpg' loading="lazy" class='company_address'/>
        </swiper-slide>
        <swiper-slide lazy="true">
            <img src='../assets/ProductQuality_wide.jpg' loading="lazy" class='product_quality'/>
            <div class='product_quality_title' v-html="t('__product_quality')"/>
        </swiper-slide>
        <swiper-slide lazy="true">
            <img src='../assets/CustomerService_wide.jpg' loading="lazy" class='customer_service'/>
            <div class='customer_service_title' v-html="t('__customer_service')"/>
        </swiper-slide>
    </swiper-container>

    <swiper-container
    :slides-per-view="1"
    :space-between="50"
    :loop="true"
    :pagination="{ clickable: true }"
    :autoplay="{ delay: 5000, disableOnInteraction: false }"
    :touchMoveStopPropagation="true"
    @swiper="onSwiper"
    @slideChange="onSlideChange"
    virtual="true"
    class='swiper_mobile'>
    <swiper-slide lazy="true">
        <img src='../assets/CompanyAddress.jpg' loading="lazy" class='company_address'/>
    </swiper-slide>
    <swiper-slide lazy="true">
        <img src='../assets/ProductQuality.jpg' loading="lazy" class='product_quality'/>
        <div class='product_quality_title' v-html="t('__product_quality')"/>
    </swiper-slide>
    <swiper-slide lazy="true">
        <img src='../assets/CustomerService.jpg' loading="lazy" class='customer_service'/>
        <div class='customer_service_title' v-html="t('__customer_service')"/>
    </swiper-slide>
    </swiper-container>
    </div>
</template>


<script>
import { useI18n } from "vue-i18n"

export default {
    components: {
    },

    setup() {

        let {t} = useI18n({
                messages: {
                    'en': {
                        "__customer_service": "Customer First,<br/>Service in Heart"
                        ,"__product_quality": "High Quality Products,<br/>Bridges to the World"
                    },
                    'zh_CN': {
                        "__customer_service": "客户至上，用心服务"
                        ,"__product_quality": "优质产品是走向世界的桥梁"
                    },
                    'zh_HK': {
                        "__customer_service": "客户至上，用心服務"
                        ,"__product_quality":"優質產品是走嚮世界的橋梁"

                    },
                    'zh_TW': {
                        "__customer_service": "客户至上，用心服務"
                        ,"__product_quality":"優質產品是走嚮世界的橋梁"
                    }
                }
        })

        const onSwiper = (swiper) => {
            console.log(swiper);
        };
        const onSlideChange = () => {
            console.log('slide change');
        };
        return {
            t,
            onSwiper,
            onSlideChange,
        };
    }
}
</script>

<style scoped>

.company_address,.product_quality,.customer_service {
    position: relative;
    width: 100%;
    height: 100%;
}

.company_address,.product_quality {
    object-fit: fill;
}

.customer_service_title {
    position: absolute;
    font-family: xingcao;
    text-shadow: 1px 1px black;
    color: white;
    z-index: 9;
}

.product_quality_title {
    position: absolute;
    font-family: xingcao;
    text-shadow: 1px 1px black;
    color: white;
    z-index: 9;
}

@media screen and (max-width: 768px){
    .swiper_pc {
        display: none;
    }

    .company_address,.customer_service,.product_quality {
        height:60vw;
    }

    .customer_service_title {
        font-weight: 700;
        font-size: 7vw;
        top: 14vw;
        left: 10vw;
    }

    .product_quality_title {
        font-weight: 700;
        font-size: 7vw;
        top: 8vw;
        left: 7.5vw;
    }
}

@media screen and (min-width: 768px) and (max-width: 1080px) {
    .swiper_pc {
        display: none
    }
    .company_address,.customer_service,.product_quality{
        height:30vw;
    }

    .customer_service_title {
        font-weight: 700;
        font-size: 4vw;
        top: 4vw;
        left: 4vw;
    }

    .product_quality_title {
        font-weight: 700;
        font-size: 4vw;
        top: 4vw;
        right: 4vw;
    }

}

@media screen and (min-width: 1080px){
    .swiper_mobile {
        display: none
    }

    .swiper_pc {
        width: 100%;
    }

    .company_address,.customer_service,.product_quality{
        height: 2rem;
        width: 100%;
    }

    .customer_service_title {
        font-size: 0.25rem;
        top: 0.1rem;
        left: 0.1rem;
    }

    .product_quality_title {
        font-weight: 700;
        font-size: 0.25rem;
        top: 0.1rem;
        right: 0.1rem;
    }
}



</style>